module.exports = __webpack_public_path__ + "img/wtr-load.6fb5dd7d.gif";